import { UnifiedClassPersonSkillsChangesDTO } from "@/api/dto/skills/UnifiedClassPersonSkillsChangesDTO";
import { useUtility } from "@/composables/useUtility";

export interface ISkillHistoryEntry {
  changeId: number;
  personId: number;
  assignId: number;
  changeAction: string;
  changedBy: string;
  assessmentId: number;
  skillId: number;
  instructor?: string;
  comments?: string;
  date?: string | null;
}

export class SkillHistoryEntry implements ISkillHistoryEntry {
  changeId: number;
  personId: number;
  assignId: number;
  changeAction: string;
  changedBy: string;
  assessmentId: number;
  skillId: number;
  instructor?: string;
  comments?: string;
  date?: string | null;

  constructor(config: ISkillHistoryEntry) {
    this.changeId = config.changeId;
    this.personId = config.personId;
    this.assignId = config.assignId;
    this.changeAction = config.changeAction;
    this.changedBy = config.changedBy;
    this.assessmentId = config.assessmentId;
    this.skillId = config.skillId;
    this.instructor = config.instructor;
    this.comments = config.comments;
    this.date = config.date;
  }
}

export const skillHistoryEntryMapper = (
  dto: UnifiedClassPersonSkillsChangesDTO,
) => {
  const { formatDateNY } = useUtility();

  return {
    changeId: dto.changeId,
    personId: dto.personId,
    assignId: dto.assignId,
    changeAction: dto.changeAction,
    changedBy: dto.changedBy,
    assessmentId: dto.assessmentId,
    skillId: dto.skillId,
    instructor: dto.instructor,
    comments: dto.comments,
    date: formatDateNY(dto.createdOn),
  };
};
